import { useState, createContext, useContext, useMemo, FC, useCallback } from 'react'
import {
  QueryState,
  QueryRequestContextProps,
  initialQueryRequest,
  WithChildren,
} from '../../../../../../_metronic/helpers'

export const QueryRequestContext =
  createContext<QueryRequestContextProps<unknown>>(initialQueryRequest)
export const QueryRequestProvider: FC<WithChildren> = ({ children }) => {
  const initialState: QueryState<unknown> = {
    ...initialQueryRequest.state,
    /*  fixedSort: [{ field: 'data', order: 'desc' }], */
  }

  const [state, setState] = useState<QueryState<unknown>>(initialState)

  const updateState = useCallback(
    (updates: Partial<QueryState<unknown>>) =>
      setState((prev) => ({
        ...prev,
        ...updates,
      })),
    []
  )

  const value = useMemo(
    () => ({
      state,
      updateState,
    }),
    [state, updateState]
  )

  return <QueryRequestContext.Provider value={value}>{children}</QueryRequestContext.Provider>
}

export const useQueryRequest = <TParams = undefined,>() =>
  useContext(QueryRequestContext) as QueryRequestContextProps<TParams>
